<template lang="pug">
    .ui-content__item-page.ui-buttons.ui-item-page
        h2.ui-item-page__title UI Button
        h5.ui-item-page__sub-title Basic usage
        .ui-block
            .row
                .col-lg-12.mb-30
                    vue-button() Default
                    vue-button(type='primary') Primary
                    vue-button(type='success') Success
                    vue-button(type='info') Info
                    vue-button(type='warning') Warning
                    vue-button(type='danger') Danger
                .col-lg-12.mb-30
                    vue-button(round) Round
                    vue-button(type='primary', round) Primary
                    vue-button(type='success', round) Success
                    vue-button(type='info', round) Info
                    vue-button(type='warning', round) Warning
                    vue-button(type='danger', round) Danger
                .col-lg-12.mb-30
                    vue-button(plain) Plain
                    vue-button(type='primary', plain) Primary
                    vue-button(type='success', plain) Success
                    vue-button(type='info', plain) Info
                    vue-button(type='warning', plain) Warning
                    vue-button(type='danger', plain) Danger
                .col-lg-12.mb-30
                    vue-button(icon='fa fa-search', circle)
                    vue-button(type='primary', icon='fa fa-search', circle)
                    vue-button(type='success', icon='fa fa-search', circle)
                    vue-button(type='info', icon='fa fa-search', circle)
                    vue-button(type='warning', icon='fa fa-star', circle)
                    vue-button(type='danger', icon='fa fa-trash', circle)
            h5.ui-item-page__sub-title Disabled Button
        .ui-block
            .row
                .col-lg-12.mb-30
                    vue-button(disabled) Default
                    vue-button(type='primary', disabled) Primary
                    vue-button(type='success', disabled) Success
                    vue-button(type='info', disabled) Info
                    vue-button(type='warning', disabled) Warning
                    vue-button(type='danger', disabled) Danger
        .ui-block
            .row
                .col-lg-3.mb-30
                    h5.ui-item-page__sub-title Text Button
                    vue-button(type='text') Text Button
                    vue-button(type='text', disabled) Text Button
                .col-lg-2.mb-30
                    h5.ui-item-page__sub-title Loading Button
                    vue-button(type='primary', :loading='true') Loading
        .ui-block
            .row
                .col-lg-3.mb-30
                    h5.ui-item-page__sub-title Icon Button
                    vue-button(type='primary', icon='fa fa-search')
                    vue-button(type='primary', icon_left='fa fa-search') Search
                    vue-button(type='primary', icon_right='fa fa-search') Search
                .col-lg-3.mb-30
                    h5.ui-item-page__sub-title Button Group
                    vue-button-group
                        vue-button(type='primary', icon_left='fa fa-angle-left') Previous Page
                        vue-button(type='primary', icon_right='fa fa-angle-right') Next Page
                .col-lg-3.mb-30
                    h5.ui-item-page__sub-title Button Group
                    vue-button-group
                        vue-button(type='primary', icon='fa fa-edit')
                        vue-button(type='primary', icon='fa fa-share')
                        vue-button(type='primary', icon='fa fa-trash')
        h5.ui-item-page__sub-title Sizes Button
        .ui-block
            .row
                .col-lg-6.mb-30
                    vue-button(size='big' type="warning" icon_right="fa fa-angle-right") Подробнее
                    vue-button(type="warning") Default
                    vue-button(size='medium' type="warning") Medium
                    vue-button(size='small' type="warning") Small
                    vue-button(size='mini' type="warning") Mini
                .col-lg-6.mb-30
                    vue-button(size='big', round) Big
                    vue-button(round) Default
                    vue-button(size='medium', round) Medium
                    vue-button(size='small', round) Small
                    vue-button(size='mini', round) Mini
</template>
<script>
    import vueButton from '../../components/button/button.vue'
    import vueButtonGroup from '../../components/button-group/button-group.vue'
    export default {
        name: 'ui-buttons',
        components: {
            vueButton,
            vueButtonGroup,
        }
    };
</script>